<svelte:head>
  <!-- 국내(cpay) 결제 스크립트는 checkout/session 응답의 payple.scriptUrl로 동적 로드한다
       (결제서비스 환경과 일치 보장). 해외(gpay)만 정적 로드 유지. -->
  {#if process.env.NODE_ENV === 'development'}
    <script src="https://demo-gpay.payple.kr/common/js/gpay-1.0.1.js"></script>
  {:else}
    <!-- <script src="https://gpay.payple.kr/common/js/gpay-1.0.1.js"></script> -->
  {/if}
</svelte:head>
<script>
	import {PRConnect} from "@projectroom/ui-lib";
	import { _, getLocaleFromNavigator } from 'svelte-i18n';
	import Cookies from 'js-cookie';
	import {onDestroy, onMount} from 'svelte';

	let paymentAgreeFlag;
	let isPaymentFlag;
	let isPaymentCompleteFlag
	let isLocalCardAgreeFlag = false;
	let plan;
	let planPrice;
	let currency;
	let locale;
	let errorMesage = "";
	let overseasPaymentParam;
	let currentCheckoutId; // checkout/session ~ 콜백 사이 주문 식별
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	// 국내 결제 스크립트 동적 로드(중복 로드 방지)
	const loadedScripts = {};
	const loadScript = (src) =>
		new Promise((resolve, reject) => {
			if (loadedScripts[src] || typeof PaypleCpayAuthCheck !== 'undefined') {
				resolve();
				return;
			}
			const s = document.createElement('script');
			s.src = src;
			s.onload = () => { loadedScripts[src] = true; resolve(); };
			s.onerror = reject;
			document.head.appendChild(s);
		});
	
	export const showPopup = (price, authType, flag, currencyParam) => {
		planPrice = price;
		plan = authType;
		isPaymentFlag = flag;
		currency = currencyParam;
	}

	onMount(() => {
        locale = Cookies.get('lang') || getLocaleFromNavigator().substring(0,2);
		// 국내 clientKey는 결제서비스 checkout/session 응답(payple.clientKey)으로 받는다.
		// 해외(overseas)만 여기서 유지.
		if (process.env.NODE_ENV === 'development') {
			overseasPaymentParam = { service_id: "demo", payCls: "demo" };
		} else {
			overseasPaymentParam = { service_id: "avatalkus" };
		}
    });

	const clickPayment = () => {
		if (!paymentAgreeFlag) {
			errorMesage = $_('project.default.115_Payment');
			return;
		}
		errorMesage = "";
		if (timeZone !== "Asia/Seoul") {
			errorMesage = $_('project.default.128');
			return;
		}
		// 결제서비스에 checkout 세션 요청 → 응답의 scriptUrl 로드 + authParams로 결제창 호출
		PRConnect.send("/api/Payment/createCheckoutSession", { plan, amount: planPrice, currency }, async data => {
			if (data.header.status === "success") {
				const { checkoutId, paypleAuthParams, payple, payer } = data.result;
				currentCheckoutId = checkoutId;
				await loadScript(payple.scriptUrl);
				PaypleCpayAuthCheck({
					...paypleAuthParams,            // clientKey·PCD_PAY_WORK(CERT)·PCD_PAY_OID 등
					PCD_PAYER_NAME: payer.name,     // payer PII는 le868에서만 채움
					PCD_PAYER_EMAIL: payer.email,
					PCD_PAYER_HP: payer.hp,
					PCD_PAY_URL: payer.returnUrl,
					callbackFunction: handlePaymentServiceCallback,
				});
			}
		});
	}

	const handlePaymentServiceCallback = (result) => {
		if (result["PCD_PAY_RST"] === "success") {
			// SPA 콜백으로 받은 빌링키(PCD_PAYER_ID)를 결제서비스로 전달해 구독 생성.
			// 권한(USER_PLANS)은 결제서비스가 보내는 invoice.paid webhook으로 반영된다.
			// PCD_PAY_WORK=AUTH: 여기선 빌링키(PCD_PAYER_ID)만 발급. 첫 달 결제는
			// payment-service가 from-checkout에서 서버사이드(PAYM)로 직접 수행한다.
			PRConnect.send("/api/Payment/registerSubscription", {
				checkoutId: currentCheckoutId,
				billingKey: result["PCD_PAYER_ID"],
			}, data => {
				if (data.header.status === "success") {
					isPaymentFlag = false;
					isPaymentCompleteFlag = true;
				}
			});
		} else {
			// 결제 실패 일 경우 실패 원인 기록 API 호출
		}
	}

	const clickRefundCheck = () => {
		paymentAgreeFlag = !paymentAgreeFlag;
		if (paymentAgreeFlag) {
			errorMesage = "";
		}
	}

	const clickPopupOff = () => {
		isPaymentFlag = false;
		errorMesage = "";
	}

	const clickRefundLink = () => {
		const link = "https://avatalk-1.gitbook.io/avatalk/undefined-1/undefined-1#id-2-2";
        window.open(link);
	}

	const clickPaymentCompletePopupOff = () => {
		isPaymentCompleteFlag = false;
		window.location.reload();
	}

	const formatCurrency = (value) => {
		const currency = locale === "ko" ? "KRW" : "USD";
		const numberValue = parseFloat(value);  // 소수점을 포함한 숫자로 변환
		if (isNaN(numberValue)) {  // 유효한 숫자인지 확인
			return 'Invalid number';  // 유효하지 않은 숫자라면 오류 메시지 반환
		}

		let options = {
			style: 'currency',
			currency: currency,
			currencyDisplay: 'symbol' // 통화 기호로 표시
		};

		// 한국 원인 경우 "원"을 붙여서 출력
		if (currency === 'KRW') {
			// 소수점 없이 출력
			options.minimumFractionDigits = 0;
			options.maximumFractionDigits = 0;
			const formattedNumber = new Intl.NumberFormat('ko-KR', options).format(numberValue);
			return formattedNumber + ' 원'; // "원"을 추가하여 반환
		} else {
			// 다른 통화의 경우 통화 기호 사용
			return new Intl.NumberFormat('en-US', options).format(numberValue);
		}
	}
</script>
<div class="plan-payment-con-popup" class:show={isPaymentFlag} on:click={clickPopupOff}>
      <div class="plan-payment-popup" on:click|stopPropagation>
        <div class="titile-text-pn popup">
          <div class="h1 margin20">{$_('project.default.116')}</div>
        </div>
        <div class="plan-payment-con">
          <div class="text-block-115">{$_('project.default.117')}</div>
          <div class="div-block-104">
            <div class="text-block-116">{plan}</div>
            <div class="text-block-117">{formatCurrency(planPrice)} / {$_('project.default.118')}</div>
          </div>
        </div>
        <div class="plan-payment-con">
          <div class="text-block-115">{$_('project.default.119')}</div>
          <div class="form-block-join w-form">
            <div id="email-form" name="email-form">
              <div class="form-wrap-inner center last">
                <div class="checkbox-grid _4">
					{#if timeZone === "Asia/Seoul"}
					<label class="w-checkbox p-radio-btn">
						<div class="w-checkbox-input w-checkbox-input--inputType-custom radio-btn active"></div>
						<span class="checkbox-label-2 w-form-label" for="checkbox-7">{$_('project.default.120')}</span>
					</label>
					{:else}
					<label class="w-checkbox p-radio-btn">
                    	<div class="w-checkbox-input w-checkbox-input--inputType-custom radio-btn active"></div>
						<span class="checkbox-label-2 w-form-label" for="checkbox-7">Global Credit Card (Visa, master)</span>
                  	</label>
					{/if}
				  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="plan-payment-con">
          <div class="text-block-115">{$_('project.default.121')}</div>
          <div class="text-block-118">{formatCurrency(planPrice)}</div>
        </div>
        <div class="checkbox-wrap payment">
          <div class="checkbox-elements"><img alt="" loading="lazy" src="/static/images/check-icon.svg" class="chracter-checkbox" class:active={paymentAgreeFlag} on:click={clickRefundCheck}>
            <div class="text-block-95 pointer" on:click={clickRefundLink}>{$_('project.default.122')}</div>
          </div>
        </div>
		{#if errorMesage }
		<div class="error">{errorMesage}</div>
		{/if}
        <div class="popup-button payment">
          <a href="#" class="payment-button w-button" on:click={clickPayment}>{$_('project.default.123')}</a>
        </div>
        <div class="x-button _2 pointer" on:click={clickPopupOff}></div>
      </div>
</div>
<div class="payment-completed-popup" class:show={isPaymentCompleteFlag} on:click={clickPaymentCompletePopupOff}>
      <div class="payment-completed" on:click|stopPropagation>
        <div class="titile-text-pn popup">
          <div class="h1 margin20">{$_('project.default.124')}</div>
        </div>
        <div class="plan-payment-con">
          <div class="text-block-115 center">{$_('project.default.125')}</div>
        </div>
        <div class="popup-button payment">
          <a href="#" class="payment-button w-button" on:click={clickPaymentCompletePopupOff}>{$_('project.default.126')}</a>
        </div>
        <div class="x-button" on:click={clickPaymentCompletePopupOff}></div>
      </div>
</div>
<style>
	.checkbox-wrap.payment {
		margin-bottom: 10px;
	}

	.chracter-checkbox.active {
		background-color: #ff558d;
	}

	.chracter-checkbox {
		border-radius: 0px;
	}

	.chracter-checkbox:focus {
		background-color: #ff558d94;
	}

	.chracter-checkbox:active {
		background-color: #ff558d94;
	}
	.chracter-checkbox:hover {
		background-color: #ff558d94;
	}

	.plan-payment-con {
		margin-bottom: 10px;
	}

	.w-checkbox-input {
		border-radius: 10px;
		width: 16px;
		height: 16px;
	}

	.p-radio-btn {
		display: flex;
	}

	.checkbox-label-2 {
		margin-top: 4px;
		margin-left: 5px;
	}

	.radio-btn:active {
		border-width: 4px;
	}

	.radio-btn.active {
		outline-offset: 0px;
    	background-color: #e55e8a;
		border-width: 4px;
		border-color: #f7f7f7;
		border-radius: 10px;
		outline: 0.1px solid #bdbdbd;
	}

	.p-radio-btn {
		cursor: pointer;
	}

	.x-button._2 {
		top: 4%;
    	right: 4%;
	}

	.error {
		font-weight: bold;
		font-size: 12px;
		color: red;
		width: 80%;
	}

	.popup-button {
		margin-bottom: 20px;
	}

	@media screen and (min-width: 1280px) {
		.plan-payment-popup {
			height: auto;
		}
	}
</style>